import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Luciana M.',
    info: '34, mamá de 2',
    text: 'Pensé que era otro PDF más... pero cuando hice la primera actividad con mi hijo de 6, se largó a reír y me abrazó. No necesité más prueba.'
  }, {
    name: 'Fernando R.',
    info: '38, papá de 3',
    text: 'Trabajo todo el día y llegaba a casa sin energía. Este pack me dio ideas simples que mis hijos esperan con ansias cada noche.'
  }, {
    name: 'Carolina S.',
    info: '41, mamá de un adolescente',
    text: 'Mi hija de 14 no me hablaba. Empecé con las preguntas del tomo 3 y ahora tenemos charlas que nunca imaginé.'
  }, {
    name: 'Andrés P.',
    info: '35, papá primerizo',
    text: 'No sabía cómo jugar con mi nena de 4 sin recurrir a la tablet. Ahora tenemos nuestros propios rituales.'
  }, {
    name: 'Gabriela T.',
    info: '39, mamá de 2',
    text: 'La culpa de mamá me comía. Este pack no me hizo perfecta, pero me hizo presente. Y eso cambió todo.'
  }];
  return <section className="py-8 px-4 bg-rose-50/40" data-id="element-226">
      <div className="max-w-4xl mx-auto" data-id="element-227">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-6" data-id="element-228">
          Lo que dicen otros padres
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-229">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-4 rounded-xl shadow-sm border border-rose-100" data-id="element-230">
              <div className="flex gap-1 mb-4" data-id="element-231">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-232" />)}
              </div>
              <p className="text-gray-700 mb-3 italic" data-id="element-233">"{t.text}"</p>
              <div className="mt-auto" data-id="element-234">
                <p className="font-bold text-gray-900" data-id="element-235">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-236">{t.info}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}